var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53333 3.6C6.03627 3.6 5.63333 4.00294 5.63333 4.5C5.63333 4.99706 6.03627 5.4 6.53333 5.4V3.6ZM6.53333 5.4H16.6667V3.6H6.53333V5.4ZM21.1 9.83333V10.9H22.9V9.83333H21.1ZM16.6667 15.3333H6.53333V17.1333H16.6667V15.3333ZM21.1 10.9C21.1 13.3485 19.1151 15.3333 16.6667 15.3333V17.1333C20.1092 17.1333 22.9 14.3426 22.9 10.9H21.1ZM16.6667 5.4C19.1151 5.4 21.1 7.38487 21.1 9.83333H22.9C22.9 6.39076 20.1092 3.6 16.6667 3.6V5.4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.2333L10.2 12.5383L10.2 19.9284L3 16.2333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBack);
export default __webpack_public_path__ + "static/media/ic_back.09d085e3f5b622fea73c5d09c03e82ad.svg";
export { ForwardRef as ReactComponent };